"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyAsisEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class NotifyAsisEvent extends web_ui_framework_1.Event {
}
exports.NotifyAsisEvent = NotifyAsisEvent;
//# sourceMappingURL=asisEvents.js.map